import axios from "../http_v2";

export default {
  // 获取列表
  list: (params) => {
    return axios.post("formbuilder/applyform/page", params);
  },


  // 要改
  uploadApi: {
    uploadImg:
      process.env.VUE_APP_FILE_DOMAIN + "opservice/ophonoredguest/savefile",
    uploadData: (params) => {
      return axios.post("formbuilder/applyFormSubmit/import/sumbit", params);
    },
  },

  // 要改
  field: {
    list: (params) => {
      return axios.get("content-service/field/list", params);
    },
    save: (params) => {
      return axios.post("content-service/field/save", params);
    },
    del: (params) => {
      return axios.get("content-service/field/delete", params);
    },
  },

  
  //合并表单
  margeForm: (params) => {
    return axios.post("formbuilder/statistics/save", params);
  },
  // 复制表单
  copyform: (params) => {
    return axios.post("formbuilder/applyform/copy", params);
  },
  // 合并表单列表
  margeFormList: (params) => {
    return axios.post("formbuilder/statistics/list", params);
  },
  downloadList: (params) => {
    return axios.post("formbuilder/statistics/export", params);
  },
  //执行
  getExecute: (params) => {
    return axios.post("formbuilder/statistics/get", params);
  },
  // 保存或者更新表单信息
  save: (params) => {
    return axios.post("formbuilder/applyform/save", params);
  },
  updateStatus: (params) => {
    return axios.post(
      "formbuilder/applyform/update/status?id=" +
        params.id +
        "&status=" +
        params.status
    );
  },
  // 获取单个表单信息
  info: (params) => {
    return axios.get("formbuilder/applyform/get/" + params);
  },
  // 复制表单
  copy: (params) => {
    return axios.post("formbuilder/applyform/copy", params);
  },
  // 删除表单
  del: (params) => {
    return axios.post("formbuilder/applyform/remove?id=" + params);
  },

  // 导入数据
  importData: (params) => {
    return axios.post("formbuilder/applyFormSubmit/import/sumbit", params);
  },
  // 合并表单列表
  margeFormList: (params) => {
    return axios.post("formbuilder/statistics/list", params);
  },
  //合并表单
  margeForm: (params) => {
    return axios.post("formbuilder/statistics/save", params);
  },
  download: (params) => {
    return axios.post("formbuilder/statistics/export", params);
  },
  getExecute: (params) => {
    return axios.post("formbuilder/statistics/get", params);
  },

  // 获取渠道信息
  channelInfoList: (params) => {
    return axios.post("marketcenter/urlChannel/list/channelTemplate", params);
  },
  // 生成渠道地址
  addChannel: (params) => {
    return axios.post("marketcenter/urlChannel/add/channel", params);
  },
  // 获取表单推广渠道的渠道信息
  getChannelList: (params) => {
    return axios.post("marketcenter/urlChannel/page/channel", params);
  },
  // 获取国内城市列表
  cityList: () => {
    return axios.get("opservice/opbasedocarea/allcity.json");
  },
  // 获取国外城市列表
  outCityList: () => {
    return axios.get("opservice/opbasedocarea/allcityAbroad.json");
  },
  // 保存或者更新分派规则
  saveApplyFormRule: (params) => {
    return axios.post("formbuilder/applyformrule/save", params);
  },
  // 组织结构接口
  orgTree: (params) => {
    return axios.post("opservice/org/tree", params);
  },

  // 管理员填写提交
  submitClueInfo: (params) => {
    return axios.post("formbuilder/applyFormSubmit/manager/save", params);
  },
  // 导出表单数据
  exportForm: (params) => {
    return axios.post("formbuilder/applyFormSubmit/export?formId=" + params);
  },

  // 线索发送
  sendEmail: (params) => {
    return axios.post("formbuilder/applyFormSubmit/send/salesman", params);
  },
  // 导出我的线索
  exportAll: (params) => {
    return axios.post("formbuilder/applyFormSubmit/export/page", params);
  },
  // 获取报表的头部
  reportHeader: (params) => {
    return axios.post(
      "formbuilder/applyform/head?form_id=" + params.id,
      params
    );
  },
  // 获取分页
  getReportPages: (params) => {
    return axios.post("formbuilder/applyform/submit/page/list", params);
  },
  // 表单模板
  getInsertTemp: (params) => {
    return axios.post(
      "formbuilder/applyFormSubmit/export/template?formId=" + params.id,
      params
    );
  },
  // 渠道总数
  channelSum: (params) => {
    return axios.post("marketcenter/urlChannel/page/channel_sum", params);
  },
  getFilePath: (params) => {
    return axios.get("formbuilder/upload/html/page/get", params);
  },
  // 查找资料列表
  queryDataFile(params) {
    return axios.get("content-service/doc_article/page", params);
  },
  // 视频列表
  getVideoList(params) {
    return axios.get("activityservice/video/list", params);
  },
  // 生成http短连接服务
  generateShortUrl(params) {
    return axios.post("https://mk-api.yybip.com/y/generatecode", params);
  },
};
